var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _g2, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanding(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 622,
    viewBox: "0 0 452 622",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.75 81.48H202.25V91.22H257.75V81.48Z",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267 91.22H193V100.96H267V91.22Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 100.96H183.75V110.7H276.25V100.96Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267 100.96H193V110.7H267V100.96Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M285.5 110.7H174.5V120.44H285.5V110.7Z",
    fill: "#87CEEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.5 120.44H165.25V130.18H174.5V120.44Z",
    fill: "#87CEEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M294.75 120.44H285.5V130.18H294.75V120.44Z",
    fill: "#87CEEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M156 130.18H146.75V247.06H156V130.18Z",
    fill: "#B0D4E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.25 130.18H304V247.06H313.25V130.18Z",
    fill: "#5FA8D3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.25 130.18H156V247.06H165.25V130.18Z",
    fill: "#D4E8F0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M304 130.18H294.75V247.06H304V130.18Z",
    fill: "#4A90C0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304 247.06H156V256.8H304V247.06Z",
    fill: "#87CEEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M294.75 256.8H165.25V266.54H294.75V256.8Z",
    fill: "#87CEEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 149.66H183.75V178.88H211.5V149.66Z",
    fill: "#FF4444"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 139.92H193V149.66H202.25V139.92Z",
    fill: "#FF6666"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 178.88H193V188.62H202.25V178.88Z",
    fill: "#CC3333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 149.66H248.5V178.88H276.25V149.66Z",
    fill: "#FFD700"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267 139.92H257.75V149.66H267V139.92Z",
    fill: "#FFED4E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267 178.88H257.75V188.62H267V178.88Z",
    fill: "#CCAC00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M243.875 188.62H216.125V217.84H243.875V188.62Z",
    fill: "#4169E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M234.625 178.88H225.375V188.62H234.625V178.88Z",
    fill: "#6A8AFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M234.625 217.84H225.375V227.58H234.625V217.84Z",
    fill: "#2C4FB3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 198.36H174.5V227.58H202.25V198.36Z",
    fill: "#32CD32"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M193 188.62H183.75V198.36H193V188.62Z",
    fill: "#5EFF5E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193 227.58H183.75V237.32H193V227.58Z",
    fill: "#228B22"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 198.36H257.75V227.58H285.5V198.36Z",
    fill: "#9370DB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 188.62H267V198.36H276.25V188.62Z",
    fill: "#B8A3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 227.58H267V237.32H276.25V227.58Z",
    fill: "#6A4DB3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.75 217.84H202.25V237.32H220.75V217.84Z",
    fill: "#FF69B4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 208.1H202.25V217.84H211.5V208.1Z",
    fill: "#FF8DC7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304 266.54H156V276.28H304V266.54Z",
    fill: "#E8E8E8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25 276.28H146.75V286.02H313.25V276.28Z",
    fill: "#C0C0C0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M304 276.28H156V286.02H304V276.28Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 286.02H137.5V295.76H322.5V286.02Z",
    fill: "#A8A8A8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25 286.02H146.75V295.76H313.25V286.02Z",
    fill: "#D0D0D0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 295.76H137.5V441.86H322.5V295.76Z",
    fill: "#2C2C2C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25 305.5H146.75V432.12H313.25V305.5Z",
    fill: "#1A1A1A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M156 295.76H146.75V441.86H156V295.76Z",
    fill: "#3A3A3A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25 295.76H304V441.86H313.25V295.76Z",
    fill: "#0A0A0A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M267 315.24H193V354.2H267V315.24Z",
    fill: "#4A4A4A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M257.75 324.98H202.25V344.46H257.75V324.98Z",
    fill: "#1A1A1A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5 329.85H211.5V339.59H248.5V329.85Z",
    fill: "#0A0A0A"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267 315.24H193V324.98H267V315.24Z",
    fill: "#666666"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267 344.46H193V354.2H267V344.46Z",
    fill: "#2A2A2A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M220.75 373.68H165.25V412.64H220.75V373.68Z",
    fill: "#C0C0C0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 383.42H174.5V402.9H211.5V383.42Z",
    fill: "#E8E8E8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 388.29H183.75V398.03H202.25V388.29Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M220.75 373.68H165.25V383.42H220.75V373.68Z",
    fill: "#D8D8D8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M220.75 402.9H165.25V412.64H220.75V402.9Z",
    fill: "#A0A0A0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M313.25 373.68H239.25V422.38H313.25V373.68Z",
    fill: "#3A3A3A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M304 383.42H248.5V412.64H304V383.42Z",
    fill: "#1A1A1A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 393.16H257.75V412.64H294.75V393.16Z",
    fill: "#0A0A0A"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.5 373.68H239.25V422.38H248.5V373.68Z",
    fill: "#4A4A4A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M331.75 441.86H128.25V461.34H331.75V441.86Z",
    fill: "#3A3A3A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 441.86H137.5V461.34H322.5V441.86Z",
    fill: "#2C2C2C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M341 461.34H119V480.82H341V461.34Z",
    fill: "#4A4A4A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M331.75 461.34H128.25V480.82H331.75V461.34Z",
    fill: "#3A3A3A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 480.82H109.75V500.3H350.25V480.82Z",
    fill: "#5A5A5A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M341 480.82H119V500.3H341V480.82Z",
    fill: "#4A4A4A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M359.5 500.3H100.5V519.78H359.5V500.3Z",
    fill: "#6A6A6A"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M350.25 500.3H109.75V519.78H350.25V500.3Z",
    fill: "#5A5A5A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M341 510.04H119V519.78H341V510.04Z",
    fill: "#3A3A3A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 324.98H276.25V334.72H285.5V324.98Z",
    fill: "#FFD700"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M276.25 329.85H267V339.59H276.25V329.85Z",
    fill: "#FFD700"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M294.75 329.85H285.5V339.59H294.75V329.85Z",
    fill: "#FFD700"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M285.5 334.72H276.25V344.46H285.5V334.72Z",
    fill: "#FFD700"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.35 124.842L287.807 107.905L285.678 111.368L313.221 128.305L315.35 124.842Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.221 128.305L285.678 111.368L281.419 118.294L308.962 135.231L313.221 128.305Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.286 125.885L289.613 113.787L285.354 120.713L305.027 132.811L309.286 125.885Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.7 144.909L265.681 108.615L263.551 112.078L322.571 148.372L324.7 144.909Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.506 150.791L259.616 109.659L257.487 113.122L324.376 154.254L326.506 150.791Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.311 156.674L253.552 110.702L236.516 138.406L311.275 184.377L328.311 156.674Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.225 122.8L253.552 110.702L249.293 117.628L268.966 129.726L273.225 122.8Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.097 124.887L249.293 117.628L245.034 124.554L256.838 131.813L261.097 124.887Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.311 156.674L308.637 144.576L291.601 172.28L311.275 184.377L328.311 156.674Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.663 173.989L290.121 157.052L283.732 167.441L311.275 184.377L317.663 173.989Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.508 148.039L271.096 126.263L268.966 129.726L304.378 151.502L306.508 148.039Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.313 153.921L265.032 127.306L262.902 130.769L306.184 157.384L308.313 153.921Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.118 159.804L258.968 128.35L252.579 138.739L303.73 170.193L310.118 159.804Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.795 167.773L256.514 141.158L254.384 144.621L297.666 171.236L299.795 167.773Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.731 168.817L258.319 147.041L256.19 150.504L291.602 172.28L293.731 168.817Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.378 151.502L268.967 129.726L266.837 133.189L302.249 154.965L304.378 151.502Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.184 157.384L262.902 130.769L256.514 141.158L299.795 167.773L306.184 157.384Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.861 165.354L260.449 143.578L258.319 147.041L293.731 168.817L295.861 165.354Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.314 152.545L270.772 135.608L268.642 139.071L296.185 156.008L298.314 152.545Z",
    fill: "#2E5F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.119 158.428L264.708 136.652L262.578 140.115L297.99 161.891L300.119 158.428Z",
    fill: "#3A7FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.99 161.891L262.578 140.115L260.449 143.578L295.86 165.354L297.99 161.891Z",
    fill: "#4A9FD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.512 143.911L268.642 139.071L266.513 142.534L274.382 147.373L276.512 143.911Z",
    fill: "#6BC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.382 147.373L270.447 144.954L268.318 148.417L272.253 150.836L274.382 147.373Z",
    fill: "#8FD9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.312 155.298L306.508 148.039L302.249 154.965L314.053 162.224L318.312 155.298Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.443 150.458L306.508 148.039L304.378 151.502L308.313 153.921L310.443 150.458Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.182 158.76L312.248 156.341L310.118 159.804L314.053 162.223L316.182 158.76Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.42 116.918L263.551 112.078L261.421 115.541L269.291 120.38L271.42 116.918Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.486 114.498L263.551 112.078L261.421 115.541L265.356 117.961L267.486 114.498Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.34 181.958L240.451 140.825L238.321 144.288L305.211 185.421L307.34 181.958Z",
    fill: "#2A2A2A"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4375 256.249L79.5891 248.669L72.2105 256.309L80.0589 263.889L87.4375 256.249Z",
    fill: "#FFD700"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6723 263.859L71.9756 248.699L68.2863 252.519L83.983 267.679L87.6723 263.859Z",
    fill: "#FFD700"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M109.573 233.33L101.725 225.75L98.0357 229.57L105.884 237.15L109.573 233.33Z",
    fill: "#CCAC00"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M105.884 237.15L98.0356 229.57L94.3463 233.39L102.195 240.97L105.884 237.15Z",
    fill: "#FFD700"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M106.119 244.76L90.4222 229.6L86.7329 233.42L102.43 248.58L106.119 244.76Z",
    fill: "#FFD700"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M102.43 248.58L86.7329 233.42L83.0436 237.24L98.7403 252.4L102.43 248.58Z",
    fill: "#FFD700"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7403 252.4L83.0436 237.24L79.3543 241.059L95.051 256.22L98.7403 252.4Z",
    fill: "#FFD700"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M95.051 256.22L79.3542 241.059L75.665 244.879L91.3617 260.04L95.051 256.22Z",
    fill: "#FFD700"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M101.96 233.36L98.0356 229.57L94.3463 233.39L98.2705 237.18L101.96 233.36Z",
    fill: "#FFED4E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2706 237.18L90.4222 229.6L86.7329 233.42L94.5813 241L98.2706 237.18Z",
    fill: "#FFE44D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5813 241L86.7329 233.42L83.0436 237.24L90.892 244.82L94.5813 241Z",
    fill: "#FFF266"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M106.119 244.76L98.2705 237.18L94.5812 241L102.43 248.58L106.119 244.76Z",
    fill: "#DDB900"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M102.43 248.58L94.5813 241L90.892 244.82L98.7404 252.4L102.43 248.58Z",
    fill: "#CCAA00"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.665 256.19L98.7404 252.4L95.0511 256.22L98.9752 260.01L102.665 256.19Z",
    fill: "#FFD700"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M106.589 259.98L102.665 256.19L98.9753 260.01L102.899 263.8L106.589 259.98Z",
    fill: "#FFD700"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M106.824 267.59L102.899 263.8L99.2101 267.62L103.134 271.41L106.824 267.59Z",
    fill: "#FFD700"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M110.748 271.38L106.824 267.59L103.134 271.41L107.058 275.2L110.748 271.38Z",
    fill: "#CCAC00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M102.665 256.19L98.7404 252.4L95.0511 256.22L98.9752 260.01L102.665 256.19Z",
    fill: "#FFE44D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M106.824 267.59L102.899 263.8L99.2101 267.62L103.134 271.41L106.824 267.59Z",
    fill: "#DDB900"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2859 263.83L91.3617 260.04L83.9831 267.679L87.9073 271.469L95.2859 263.83Z",
    fill: "#FFD700"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2101 267.62L95.2859 263.83L87.9073 271.469L91.8315 275.259L99.2101 267.62Z",
    fill: "#FFD700"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4449 275.23L95.5208 271.44L91.8315 275.259L95.7556 279.049L99.4449 275.23Z",
    fill: "#FFD700"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M103.369 279.02L99.4449 275.23L95.7556 279.049L99.6798 282.84L103.369 279.02Z",
    fill: "#FFD700"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M107.293 282.81L103.369 279.02L99.6798 282.84L103.604 286.63L107.293 282.81Z",
    fill: "#FFD700"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M111.218 286.6L107.293 282.81L103.604 286.63L107.528 290.42L111.218 286.6Z",
    fill: "#CCAC00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2101 267.62L95.2859 263.83L87.9073 271.469L91.8315 275.259L99.2101 267.62Z",
    fill: "#DDB900"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M103.369 279.02L99.4449 275.23L95.7556 279.049L99.6798 282.84L103.369 279.02Z",
    fill: "#CCAA00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M107.293 282.81L103.369 279.02L99.6798 282.84L103.604 286.63L107.293 282.81Z",
    fill: "#CCAA00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M84.218 275.289L80.2938 271.499L76.6045 275.319L80.5287 279.109L84.218 275.289Z",
    fill: "#FFD700"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1422 279.079L84.218 275.289L80.5287 279.109L84.4529 282.899L88.1422 279.079Z",
    fill: "#FFD700"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4529 282.899L80.5287 279.109L76.8394 282.929L80.7636 286.719L84.4529 282.899Z",
    fill: "#FFD700"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3771 286.689L84.4529 282.899L80.7636 286.719L84.6878 290.509L88.3771 286.689Z",
    fill: "#FFD700"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6877 290.509L80.7635 286.719L77.0743 290.539L80.9984 294.329L84.6877 290.509Z",
    fill: "#CCAC00"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1422 279.079L84.218 275.289L80.5287 279.109L84.4529 282.899L88.1422 279.079Z",
    fill: "#DDB900"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3771 286.689L84.4529 282.899L80.7636 286.719L84.6878 290.509L88.3771 286.689Z",
    fill: "#CCAA00"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2938 271.499L64.597 256.339L60.9077 260.159L76.6045 275.319L80.2938 271.499Z",
    fill: "#FFD700"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6044 275.319L60.9077 260.159L57.2184 263.979L72.9151 279.139L76.6044 275.319Z",
    fill: "#FFD700"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9152 279.139L57.2185 263.979L53.5292 267.798L69.2259 282.959L72.9152 279.139Z",
    fill: "#FFD700"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3017 279.169L57.4534 271.589L53.7641 275.408L61.6124 282.988L65.3017 279.169Z",
    fill: "#FFD700"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6124 282.988L53.764 275.408L50.0747 279.228L57.9231 286.808L61.6124 282.988Z",
    fill: "#FFD700"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9231 286.808L50.0747 279.228L46.3854 283.048L54.2338 290.628L57.9231 286.808Z",
    fill: "#FFD700"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2339 290.628L46.3855 283.048L42.6962 286.868L50.5446 294.448L54.2339 290.628Z",
    fill: "#CCAC00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4454 263.919L64.597 256.339L60.9077 260.159L68.7561 267.739L72.4454 263.919Z",
    fill: "#FFF266"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2938 271.499L72.4454 263.919L68.7561 267.739L76.6045 275.319L80.2938 271.499Z",
    fill: "#DDB900"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6045 275.319L68.7561 267.739L65.0668 271.559L72.9152 279.139L76.6045 275.319Z",
    fill: "#CCAA00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9151 279.139L65.0668 271.559L61.3775 275.379L69.2258 282.959L72.9151 279.139Z",
    fill: "#CCAA00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3017 279.169L61.3776 275.379L57.6883 279.198L61.6124 282.988L65.3017 279.169Z",
    fill: "#BB9900"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6124 282.988L57.6882 279.198L53.9989 283.018L57.9231 286.808L61.6124 282.988Z",
    fill: "#BB9900"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5972 256.339L60.673 252.549L56.9837 256.369L60.9079 260.159L64.5972 256.339Z",
    fill: "#FFD700"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M60.673 252.549L56.7488 248.759L53.0595 252.579L56.9837 256.369L60.673 252.549Z",
    fill: "#FFD700"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9836 256.369L53.0594 252.578L49.3702 256.398L53.2943 260.188L56.9836 256.369Z",
    fill: "#FFD700"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0594 252.579L49.1353 248.788L45.446 252.608L49.3701 256.398L53.0594 252.579Z",
    fill: "#FFD700"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3702 256.398L45.446 252.608L41.7567 256.428L45.6809 260.218L49.3702 256.398Z",
    fill: "#CCAC00"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5972 256.339L60.673 252.549L56.9837 256.369L60.9079 260.159L64.5972 256.339Z",
    fill: "#FFE44D"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M60.673 252.549L56.7488 248.759L53.0595 252.579L56.9837 256.369L60.673 252.549Z",
    fill: "#FFF68F"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M75.665 244.879L71.7408 241.089L64.3623 248.729L68.2864 252.519L75.665 244.879Z",
    fill: "#FFD700"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7408 241.089L67.8167 237.299L60.4381 244.939L64.3622 248.729L71.7408 241.089Z",
    fill: "#FFD700"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1273 241.119L60.2031 237.329L56.5138 241.149L60.438 244.939L64.1273 241.119Z",
    fill: "#FFD700"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2031 237.329L56.2789 233.539L52.5896 237.359L56.5138 241.149L60.2031 237.329Z",
    fill: "#FFD700"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2789 233.539L52.3547 229.749L48.6654 233.569L52.5896 237.359L56.2789 233.539Z",
    fill: "#FFD700"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3547 229.749L48.4305 225.959L44.7412 229.779L48.6654 233.569L52.3547 229.749Z",
    fill: "#CCAC00"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M75.665 244.879L71.7408 241.089L64.3623 248.729L68.2864 252.519L75.665 244.879Z",
    fill: "#FFE44D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7408 241.089L67.8167 237.299L60.4381 244.939L64.3622 248.729L71.7408 241.089Z",
    fill: "#FFF68F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1273 241.119L60.2031 237.329L56.5138 241.149L60.438 244.939L64.1273 241.119Z",
    fill: "#FFFAAB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0436 237.24L79.1194 233.45L75.4301 237.269L79.3543 241.059L83.0436 237.24Z",
    fill: "#FFD700"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1194 233.449L75.1952 229.659L71.5059 233.479L75.4301 237.269L79.1194 233.449Z",
    fill: "#FFD700"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5058 233.479L67.5817 229.689L63.8924 233.509L67.8166 237.299L71.5058 233.479Z",
    fill: "#FFD700"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5817 229.689L63.6575 225.899L59.9682 229.719L63.8924 233.509L67.5817 229.689Z",
    fill: "#CCAC00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0436 237.24L79.1194 233.45L75.4301 237.269L79.3543 241.059L83.0436 237.24Z",
    fill: "#FFE44D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1194 233.449L75.1952 229.659L71.5059 233.479L75.4301 237.269L79.1194 233.449Z",
    fill: "#FFF68F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M98.2705 237.18L94.3463 233.39L90.657 237.21L94.5812 241L98.2705 237.18Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M79.5891 248.669L75.6649 244.879L71.9756 248.699L75.8998 252.489L79.5891 248.669Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M83.7482 260.069L79.824 256.279L76.1347 260.099L80.0589 263.889L83.7482 260.069Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.624 227.768L321.676 237.297L323.122 240.475L344.069 230.945L342.624 227.768Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.054 228.222L317.137 243.197L318.582 246.374L351.5 231.399L350.054 228.222Z",
    fill: "#9D7D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.484 228.676L312.597 249.097L314.043 252.274L358.93 231.853L357.484 228.676Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.915 229.13L308.058 254.997L309.503 258.174L366.36 232.307L364.915 229.13Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.345 229.585L303.518 260.897L304.963 264.074L373.79 232.762L372.345 229.585Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.783 231.4L301.971 265.435L303.416 268.612L378.228 234.577L376.783 231.4Z",
    fill: "#D4B587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.221 233.216L300.424 269.974L301.869 273.151L382.666 236.393L381.221 233.216Z",
    fill: "#D4B587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.659 235.032L298.876 274.512L300.322 277.689L387.104 238.209L385.659 235.032Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.096 236.847L297.329 279.05L298.775 282.227L391.542 240.024L390.096 236.847Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.542 240.024L298.775 282.227L300.22 285.404L392.987 243.201L391.542 240.024Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.084 233.668L323.122 240.474L324.567 243.652L339.53 236.845L338.084 233.668Z",
    fill: "#E8D4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.53 236.845L318.582 246.374L320.027 249.551L340.975 240.022L339.53 236.845Z",
    fill: "#DCC797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.975 240.022L314.042 252.274L315.488 255.451L342.42 243.199L340.975 240.022Z",
    fill: "#D4BA8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.42 243.198L309.503 258.174L310.948 261.351L343.866 246.376L342.42 243.198Z",
    fill: "#CCB27D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.485 228.676L342.522 235.483L343.967 238.66L358.93 231.853L357.485 228.676Z",
    fill: "#9D7D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.915 229.13L349.952 235.937L351.398 239.114L366.36 232.307L364.915 229.13Z",
    fill: "#8B6F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.345 229.585L357.383 236.392L358.828 239.569L373.79 232.762L372.345 229.585Z",
    fill: "#7A5F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.783 231.4L364.813 236.846L366.258 240.023L378.228 234.577L376.783 231.4Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.221 233.216L372.243 237.3L373.689 240.477L382.666 236.393L381.221 233.216Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.659 235.032L376.681 239.116L378.126 242.293L387.104 238.209L385.659 235.032Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.096 236.847L381.119 240.931L382.564 244.108L391.542 240.024L390.096 236.847Z",
    fill: "#5A4020"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M320.028 249.551L317.035 250.913L317.758 252.501L320.75 251.14L320.028 249.551Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.735 248.417L323.743 249.778L324.465 251.367L327.458 250.005L326.735 248.417Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M334.99 242.744L331.997 244.106L332.72 245.694L335.713 244.333L334.99 242.744Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M341.698 241.61L338.705 242.971L339.428 244.56L342.42 243.198L341.698 241.61Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M349.952 235.937L346.96 237.299L347.683 238.887L350.675 237.526L349.952 235.937Z",
    fill: "#A5865A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M316.933 258.628L313.941 259.989L314.663 261.578L317.656 260.216L316.933 258.628Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.633 256.132L323.641 257.494L324.364 259.082L327.356 257.721L326.633 256.132Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M334.888 250.46L331.896 251.821L332.618 253.41L335.611 252.048L334.888 250.46Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M347.581 246.603L344.588 247.964L345.311 249.553L348.303 248.191L347.581 246.603Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M358.828 239.569L355.836 240.93L356.558 242.518L359.551 241.157L358.828 239.569Z",
    fill: "#B8956B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M313.839 267.705L310.846 269.066L311.569 270.655L314.562 269.293L313.839 267.705Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M326.532 263.848L323.539 265.209L324.262 266.798L327.254 265.436L326.532 263.848Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M337.779 256.814L334.786 258.175L335.509 259.764L338.502 258.402L337.779 256.814Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M353.464 251.595L350.471 252.957L351.194 254.545L354.187 253.184L353.464 251.595Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M367.704 243.2L364.711 244.561L365.434 246.15L368.426 244.788L367.704 243.2Z",
    fill: "#C4A577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.115 266.345L306.205 282.682L319.213 311.275L355.123 294.938L342.115 266.345Z",
    fill: "#D4C5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.183 278.597L306.205 282.682L310.541 292.213L319.519 288.128L315.183 278.597Z",
    fill: "#E8DCC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.613 279.052L310.643 284.497L314.979 294.028L326.949 288.583L322.613 279.052Z",
    fill: "#F0E6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.342 282.23L340.364 286.314L346.146 299.022L355.123 294.938L349.342 282.23Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.232 288.584L340.262 294.03L343.153 300.384L355.123 294.938L352.232 288.584Z",
    fill: "#A89880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.002 245.924L351.092 262.261L364.101 290.854L400.01 274.517L387.002 245.924Z",
    fill: "#D4C5A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.002 245.924L378.025 250.008L382.361 259.539L391.338 255.455L387.002 245.924Z",
    fill: "#C4B59A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.455 250.462L373.485 255.908L377.821 265.439L389.791 259.993L385.455 250.462Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.282 271.339L364.304 275.423L370.085 288.131L379.063 284.047L373.282 271.339Z",
    fill: "#B8A890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.157 274.97L370.187 280.416L373.078 286.77L385.048 281.324L382.157 274.97Z",
    fill: "#A89880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.167 275.875L315.182 278.597L328.191 307.191L334.176 304.468L321.167 275.875Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.175 277.236L315.182 278.597L328.191 307.191L331.183 305.829L318.175 277.236Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.115 266.345L336.13 269.068L349.138 297.661L355.123 294.938L342.115 266.345Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.122 267.706L336.13 269.068L349.138 297.661L352.13 296.299L339.122 267.706Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.077 259.538L351.092 262.261L364.1 290.854L370.085 288.131L357.077 259.538Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.085 260.899L351.092 262.261L364.1 290.854L367.093 289.493L354.085 260.899Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.025 250.008L372.04 252.731L385.048 281.324L391.033 278.601L378.025 250.008Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.032 251.37L372.04 252.731L385.048 281.324L388.04 279.963L375.032 251.37Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.975 267.253L342.013 274.06L352.13 296.299L367.093 289.492L356.975 267.253Z",
    fill: "#5A4020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.975 267.253L342.013 274.06L343.458 277.237L358.421 270.43L356.975 267.253Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.006 272.699L342.013 274.06L352.13 296.299L355.123 294.938L345.006 272.699Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.976 267.253L353.983 268.615L364.1 290.854L367.093 289.493L356.976 267.253Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.428 271.792L346.451 275.876L347.896 279.053L356.874 274.969L355.428 271.792Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.319 278.146L349.342 282.23L350.787 285.407L359.764 281.323L358.319 278.146Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.21 284.5L352.232 288.584L353.678 291.761L362.655 287.677L361.21 284.5Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.436 273.153L349.443 274.515L356.67 290.4L359.663 289.038L352.436 273.153Z",
    fill: "#7A6040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.042 279.734L356.049 281.096L357.495 284.273L360.487 282.911L359.042 279.734Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62 280.413L310.643 284.497L314.979 294.028L323.956 289.944L319.62 280.413Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62 280.413L310.643 284.497L311.365 286.086L320.343 282.002L319.62 280.413Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.139 283.816L310.643 284.497L314.979 294.028L316.475 293.348L312.139 283.816Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.88 282.115L314.383 282.795L318.719 292.326L320.216 291.646L315.88 282.115Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.427 284.384L312.449 288.469L313.172 290.057L322.15 285.973L321.427 284.384Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.854 284.044L312.862 285.405L314.307 288.582L317.3 287.221L315.854 284.044Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.455 250.462L376.478 254.547L380.814 264.078L389.791 259.993L385.455 250.462Z",
    fill: "#4A3010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.455 250.462L376.478 254.547L377.2 256.135L386.178 252.051L385.455 250.462Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.974 253.866L376.478 254.547L380.814 264.078L382.31 263.397L377.974 253.866Z",
    fill: "#3A2010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.714 252.164L380.218 252.845L384.554 262.376L386.05 261.695L381.714 252.164Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.262 254.434L378.284 258.518L379.007 260.106L387.984 256.022L387.262 254.434Z",
    fill: "#6A5030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M381.689 254.093L378.696 255.454L380.142 258.631L383.134 257.27L381.689 254.093Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.995 271.794L313.228 313.998L314.673 317.175L407.441 274.971L405.995 271.794Z",
    fill: "#8B7355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.441 274.971L314.673 317.175L316.119 320.352L408.886 278.148L407.441 274.971Z",
    fill: "#7A6245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.809 289.491L332.832 293.575L334.277 296.752L343.255 292.668L341.809 289.491Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.247 291.307L331.285 298.114L334.176 304.468L349.138 297.661L346.247 291.307Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.146 299.022L337.168 303.106L338.613 306.283L347.591 302.199L346.146 299.022Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.27 295.391L334.277 296.752L337.168 303.106L340.161 301.745L337.27 295.391Z",
    fill: "#7A6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.719 273.154L368.742 277.239L370.187 280.416L379.165 276.331L377.719 273.154Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.157 274.97L367.195 281.777L370.085 288.131L385.048 281.324L382.157 274.97Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.055 282.685L373.078 286.77L374.523 289.947L383.501 285.862L382.055 282.685Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18 279.054L370.187 280.416L373.078 286.77L376.07 285.408L373.18 279.054Z",
    fill: "#7A6A5A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M351.703 215.968L348.711 217.329L350.156 220.506L353.148 219.145L351.703 215.968Z",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M350.156 220.506L347.163 221.868L348.609 225.045L351.601 223.683L350.156 220.506Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M356.141 217.784L353.148 219.145L354.594 222.322L357.586 220.961L356.141 217.784Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M354.594 222.322L351.601 223.683L353.047 226.86L356.039 225.499L354.594 222.322Z",
    fill: "#D0D0D0"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M328.184 51.8722L320.348 55.5786L321.807 58.6644L329.643 54.9581L328.184 51.8722Z",
    fill: "#C0392B"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M321.807 58.6644L317.889 60.5176L320.808 66.6893L324.726 64.8361L321.807 58.6644Z",
    fill: "#C0392B"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M320.809 66.6893L316.891 68.5425L319.81 74.7142L323.728 72.861L320.809 66.6893Z",
    fill: "#C0392B"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M363.446 35.1937L355.61 38.9L357.069 41.9859L364.905 38.2795L363.446 35.1937Z",
    fill: "#C0392B"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M368.823 36.4264L364.905 38.2795L367.824 44.4513L371.742 42.5981L368.823 36.4264Z",
    fill: "#C0392B"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 40.7449L371.742 42.5981L374.662 48.7698L378.58 46.9166L375.66 40.7449Z",
    fill: "#C0392B"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M329.643 54.9581L321.807 58.6644L327.646 71.0079L335.482 67.3015L329.643 54.9581Z",
    fill: "#E74C3C"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M336.02 48.1659L328.184 51.8723L335.482 67.3016L343.318 63.5952L336.02 48.1659Z",
    fill: "#E74C3C"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M342.396 41.3737L334.56 45.08L343.318 63.5952L351.154 59.8888L342.396 41.3737Z",
    fill: "#E74C3C"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M351.692 40.7532L343.856 44.4595L351.154 59.8888L358.99 56.1825L351.692 40.7532Z",
    fill: "#E74C3C"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M360.987 40.1327L353.151 43.8391L358.99 56.1825L366.826 52.4761L360.987 40.1327Z",
    fill: "#E74C3C"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M368.823 36.4264L360.987 40.1328L366.826 52.4762L374.662 48.7698L368.823 36.4264Z",
    fill: "#E74C3C"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 40.7449L320.808 66.6893L323.728 72.8611L378.58 46.9167L375.66 40.7449Z",
    fill: "#E74C3C"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M374.662 48.7698L327.646 71.0079L330.565 77.1796L377.581 54.9415L374.662 48.7698Z",
    fill: "#E74C3C"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M373.663 56.7947L334.483 75.3264L337.402 81.4981L376.582 62.9664L373.663 56.7947Z",
    fill: "#E74C3C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M372.664 64.8196L341.32 79.645L344.239 85.8167L375.583 70.9913L372.664 64.8196Z",
    fill: "#E74C3C"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M371.665 72.8445L348.157 83.9635L351.076 90.1352L374.584 79.0162L371.665 72.8445Z",
    fill: "#E74C3C"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M370.666 80.8694L354.994 88.282L357.913 94.4538L373.585 87.0411L370.666 80.8694Z",
    fill: "#E74C3C"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M369.667 88.8943L361.831 92.6006L363.291 95.6865L371.127 91.9802L369.667 88.8943Z",
    fill: "#E74C3C"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M336.02 48.1659L328.184 51.8723L329.643 54.9581L337.479 51.2518L336.02 48.1659Z",
    fill: "#FF6B5A"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M342.396 41.3737L334.56 45.08L336.02 48.1659L343.856 44.4595L342.396 41.3737Z",
    fill: "#FF8577"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M329.643 54.9581L321.807 58.6644L324.726 64.8361L332.562 61.1298L329.643 54.9581Z",
    fill: "#FF6B5A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M337.479 51.2517L329.643 54.9581L332.562 61.1298L340.398 57.4234L337.479 51.2517Z",
    fill: "#FF8577"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M343.856 44.4596L336.02 48.1659L338.939 54.3376L346.775 50.6313L343.856 44.4596Z",
    fill: "#FFA094"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M340.398 57.4235L320.808 66.6893L323.728 72.8611L343.318 63.5952L340.398 57.4235Z",
    fill: "#FF8577"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M346.775 50.6312L338.939 54.3376L341.858 60.5093L349.694 56.803L346.775 50.6312Z",
    fill: "#FFB5AB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M368.823 36.4264L360.987 40.1328L366.826 52.4762L374.662 48.7698L368.823 36.4264Z",
    fill: "#C0392B"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M375.66 40.745L367.824 44.4513L370.744 50.623L378.58 46.9167L375.66 40.745Z",
    fill: "#C0392B"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M374.662 48.7699L362.908 54.3294L365.827 60.5011L377.581 54.9416L374.662 48.7699Z",
    fill: "#C0392B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M373.663 56.7947L361.909 62.3542L364.828 68.526L376.582 62.9665L373.663 56.7947Z",
    fill: "#A0301B"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M372.664 64.8196L360.91 70.3792L363.829 76.5509L375.583 70.9914L372.664 64.8196Z",
    fill: "#A0301B"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M371.665 72.8445L359.911 78.4041L362.83 84.5758L374.584 79.0163L371.665 72.8445Z",
    fill: "#A0301B"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M374.584 79.0163L358.912 86.429L361.831 92.6007L377.503 85.188L374.584 79.0163Z",
    fill: "#A0301B"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M373.585 87.0412L365.749 90.7475L367.209 93.8334L375.045 90.127L373.585 87.0412Z",
    fill: "#A0301B"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M331.103 58.044L327.185 59.8972L328.645 62.983L332.563 61.1298L331.103 58.044Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M337.479 51.2517L333.561 53.1049L335.021 56.1908L338.939 54.3376L337.479 51.2517Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3531 101.026L82.3389 103.129L83.3906 105.636L88.4049 103.533L87.3531 101.026Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.405 103.533L80.8835 106.688L81.9353 109.195L89.4567 106.04L88.405 103.533Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4566 106.04L81.9352 109.195L84.0386 114.209L91.56 111.054L89.4566 106.04Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5601 111.054L84.0387 114.209L85.0904 116.716L92.6118 113.561L91.5601 111.054Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6118 113.561L87.5975 115.665L88.6493 118.172L93.6635 116.068L92.6118 113.561Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3907 105.636L80.8835 106.688L81.9353 109.195L84.4424 108.143L83.3907 105.636Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4423 108.143L81.9352 109.195L84.0386 114.209L86.5458 113.158L84.4423 108.143Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.96 85.2496L119.946 87.3531L120.998 89.8602L126.012 87.7568L124.96 85.2496Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.519 86.705L120.998 89.8602L122.05 92.3674L129.571 89.2122L128.519 86.705Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.571 89.2122L122.049 92.3674L124.153 97.3816L131.674 94.2265L129.571 89.2122Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.674 94.2265L124.153 97.3817L125.205 99.8888L132.726 96.7336L131.674 94.2265Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.219 97.7853L125.205 99.8888L126.256 102.396L131.271 100.292L130.219 97.7853Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.519 86.705L126.012 87.7568L127.064 90.2639L129.571 89.2122L128.519 86.705Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.571 89.2122L127.064 90.2639L129.167 95.2782L131.674 94.2265L129.571 89.2122Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.335 83.3906L87.7568 94.9596L88.8086 97.4667L116.387 85.8977L115.335 83.3906Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.894 84.846L86.3015 98.5184L87.3532 101.026L119.946 87.3531L118.894 84.846Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.387 85.8977L88.8086 97.4667L89.8603 99.9738L117.439 88.4048L116.387 85.8977Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.946 87.3531L87.3531 101.026L88.4049 103.533L120.998 89.8603L119.946 87.3531Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.998 89.8603L88.4049 103.533L89.4566 106.04L122.049 92.3674L120.998 89.8603Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.542 93.4191L91.9637 104.988L93.0155 107.495L120.594 95.9262L119.542 93.4191Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.594 95.9262L93.0155 107.495L94.0672 110.002L121.646 98.4334L120.594 95.9262Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.139 99.4851L96.5743 108.951L97.6261 111.458L120.19 101.992L119.139 99.4851Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.19 101.992L97.6261 111.458L98.6778 113.965L121.242 104.499L120.19 101.992Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.735 105.551L101.185 112.913L102.237 115.42L119.787 108.058L118.735 105.551Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.787 108.058L102.237 115.42L103.288 117.927L120.838 110.565L119.787 108.058Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.331 111.617L105.796 116.876L106.847 119.383L119.383 114.124L118.331 111.617Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8745 97.8704L89.8602 99.9739L90.912 102.481L95.9262 100.378L94.8745 97.8704Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4334 99.3258L90.912 102.481L91.9637 104.988L99.4851 101.833L98.4334 99.3258Z",
    fill: "#FFF266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.992 100.781L94.4708 103.936L95.5226 106.444L103.044 103.288L101.992 100.781Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.551 102.237L95.5226 106.444L96.5743 108.951L106.603 104.744L105.551 102.237Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.603 104.744L99.0814 107.899L100.133 110.406L107.655 107.251L106.603 104.744Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.147 108.303L100.133 110.406L101.185 112.913L106.199 110.81L105.147 108.303Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.946 87.3531L112.425 90.5083L113.476 93.0154L120.998 89.8603L119.946 87.3531Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.491 90.912L110.969 94.0672L112.021 96.5743L119.542 93.4192L118.491 90.912Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.542 93.4191L112.021 96.5743L113.073 99.0814L120.594 95.9262L119.542 93.4191Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.087 96.978L110.565 100.133L111.617 102.64L119.139 99.4851L118.087 96.978Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.139 99.4851L111.617 102.64L112.669 105.147L120.19 101.992L119.139 99.4851Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.683 103.044L112.669 105.147L113.721 107.655L118.735 105.551L117.683 103.044Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.89 113.073L104.34 120.435L105.392 122.942L122.942 115.58L121.89 113.073Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.383 114.124L106.847 119.383L107.899 121.89L120.435 116.631L119.383 114.124Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.928 117.683L110.406 120.838L111.458 123.345L118.979 120.19L117.928 117.683Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979 120.19L111.458 123.345L112.51 125.853L120.031 122.697L118.979 120.19Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.031 122.697L112.51 125.853L114.613 130.867L122.134 127.712L120.031 122.697Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.134 127.712L114.613 130.867L115.665 133.374L123.186 130.219L122.134 127.712Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.965 122.294L111.458 123.345L112.51 125.853L115.017 124.801L113.965 122.294Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.017 124.801L112.51 125.853L114.613 130.867L117.12 129.815L115.017 124.801Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979 120.19L116.472 121.242L117.524 123.749L120.031 122.697L118.979 120.19Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.031 122.697L117.524 123.749L119.627 128.763L122.134 127.712L120.031 122.697Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.693 129.167L113.158 134.426L114.209 136.933L126.745 131.674L125.693 129.167Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.252 130.623L111.702 137.985L112.754 140.492L130.304 133.13L129.252 130.623Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.745 131.674L114.209 136.933L115.261 139.44L127.797 134.181L126.745 131.674Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.811 132.078L110.247 141.543L111.299 144.051L133.863 134.585L132.811 132.078Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37 133.533L108.791 145.102L109.843 147.609L137.422 136.04L136.37 133.533Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.422 136.041L109.843 147.609L110.895 150.117L138.473 138.548L137.422 136.041Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.261 139.44L110.247 141.543L111.299 144.051L116.313 141.947L115.261 139.44Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.313 141.947L108.791 145.102L109.843 147.609L117.365 144.454L116.313 141.947Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.811 132.078L125.29 135.233L126.341 137.74L133.863 134.585L132.811 132.078Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37 133.533L128.849 136.688L129.9 139.196L137.422 136.04L136.37 133.533Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.422 136.04L129.9 139.196L130.952 141.703L138.473 138.548L137.422 136.04Z",
    fill: "#BB9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.981 137.496L108.388 151.168L109.44 153.675L142.032 140.003L140.981 137.496Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.473 138.548L110.895 150.117L111.947 152.624L139.525 141.055L138.473 138.548Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.539 138.951L106.932 154.727L107.984 157.234L145.591 141.459L144.539 138.951Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.032 140.003L109.439 153.676L110.491 156.183L143.084 142.51L142.032 140.003Z",
    fill: "#7A7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M95.9263 100.378L93.4192 101.429L94.4709 103.936L96.9781 102.885L95.9263 100.378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M99.4852 101.833L96.978 102.885L98.0298 105.392L100.537 104.34L99.4852 101.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M102.396 94.7152L99.8888 95.767L100.941 98.2741L103.448 97.2224L102.396 94.7152Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.028 394.1L102.677 397.879L104.833 403.214L114.184 399.436L112.028 394.1Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.184 399.436L104.833 403.214L109.145 413.885L118.496 410.106L114.184 399.436Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.508 401.325L104.833 403.214L106.989 408.55L111.664 406.66L109.508 401.325Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56 378.094L100.884 379.983L107.352 395.99L112.028 394.1L105.56 378.094Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56 378.094L100.884 379.983L103.04 385.319L107.716 383.429L105.56 378.094Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.872 388.765L105.196 390.654L107.352 395.99L112.028 394.1L109.872 388.765Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84 363.869L112.028 394.1L114.184 399.436L188.996 369.204L186.84 363.869Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.347 365.426L114.184 399.436L118.496 410.106L202.659 376.096L198.347 365.426Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.308 379.875L118.496 410.106L120.652 415.442L195.464 385.211L193.308 379.875Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.238 388.099L118.86 397.546L121.016 402.881L144.394 393.434L142.238 388.099Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.941 380.541L142.238 388.099L144.394 393.434L163.097 385.877L160.941 380.541Z",
    fill: "#A0D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.152 374.54L167.773 383.987L169.929 389.322L193.308 379.875L191.152 374.54Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.632 381.765L169.929 389.323L172.085 394.658L190.788 387.1L188.632 381.765Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.347 365.426L188.996 369.204L193.308 379.875L202.659 376.096L198.347 365.426Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.023 363.536L198.347 365.426L202.659 376.096L207.335 374.207L203.023 363.536Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.855 366.982L205.179 368.871L207.335 374.207L212.011 372.317L209.855 366.982Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.023 363.536L198.347 365.426L200.503 370.761L205.179 368.872L203.023 363.536Z",
    fill: "#A0D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.672 367.315L184.32 371.094L186.476 376.429L195.828 372.65L193.672 367.315Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.996 369.204L184.32 371.094L186.476 376.429L191.152 374.54L188.996 369.204Z",
    fill: "#5A8AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.161 353.864L122.107 365.201L124.263 370.536L152.317 359.2L150.161 353.864Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.669 355.421L114.911 374.315L117.067 379.65L163.825 360.756L161.669 355.421Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.501 358.867L112.392 381.54L114.548 386.875L170.657 364.202L168.501 358.867Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.332 362.313L109.872 388.765L112.028 394.1L177.488 367.648L175.332 362.313Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.488 367.648L112.028 394.1L114.184 399.436L179.644 372.983L177.488 367.648Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.966 362.978L124.263 370.536L126.419 375.872L145.122 368.314L142.966 362.978Z",
    fill: "#8FC9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.446 370.203L117.067 379.651L119.223 384.986L142.602 375.539L140.446 370.203Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.602 375.539L114.548 386.875L116.704 392.211L144.758 380.874L142.602 375.539Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.501 358.867L154.473 364.535L156.629 369.87L170.657 364.202L168.501 358.867Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.332 362.313L161.305 367.981L163.461 373.316L177.488 367.648L175.332 362.313Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.112 388.99L120.652 415.442L122.808 420.777L188.268 394.325L186.112 388.99Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.593 396.214L127.484 418.888L129.64 424.223L185.749 401.55L183.593 396.214Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.073 403.439L134.315 422.334L136.471 427.669L183.229 408.775L181.073 403.439Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.877 412.554L145.823 423.89L147.979 429.226L176.033 417.889L173.877 412.554Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.862 409.44L127.484 418.888L129.64 424.223L153.018 414.776L150.862 409.44Z",
    fill: "#7AAFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.593 396.214L174.241 399.993L176.397 405.329L185.749 401.55L183.593 396.214Z",
    fill: "#4A6F90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.073 403.439L171.721 407.218L173.877 412.554L183.229 408.775L181.073 403.439Z",
    fill: "#3A5F80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.785 375.206L144.758 380.874L146.914 386.209L160.941 380.541L158.785 375.206Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.409 396.547L153.382 402.216L155.538 407.551L169.565 401.883L167.409 396.547Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.941 380.541L146.914 386.209L153.382 402.216L167.409 396.547L160.941 380.541Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59 384.32L146.914 386.209L153.382 402.216L158.058 400.326L151.59 384.32Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.941 380.541L156.266 382.431L162.734 398.437L167.409 396.547L160.941 380.541Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.887 391.878L128.211 393.767L130.367 399.103L135.043 397.213L132.887 391.878Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.238 388.099L137.563 389.988L139.719 395.324L144.394 393.434L142.238 388.099Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.293 376.762L165.617 378.652L167.773 383.987L172.449 382.098L170.293 376.762Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.644 372.983L174.969 374.873L177.125 380.208L181.8 378.319L179.644 372.983Z",
    fill: "#2A4A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.549 392.822L128.211 393.767L129.289 396.435L131.627 395.49L130.549 392.822Z",
    fill: "#5A8AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.9 389.044L137.563 389.988L138.641 392.656L140.978 391.711L139.9 389.044Z",
    fill: "#5A8AAA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.476 286.924L196.728 288.983L198.971 291.976L201.719 289.918L199.476 286.924Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.971 282.807L202.223 284.866L204.466 287.859L207.214 285.801L204.971 282.807Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.466 278.69L207.718 280.749L209.961 283.742L212.709 281.684L210.466 278.69Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.961 274.573L213.213 276.631L215.456 279.625L218.204 277.566L215.961 274.573Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.456 270.456L218.708 272.514L220.951 275.508L223.699 273.449L221.456 270.456Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.951 266.339L224.203 268.397L226.446 271.391L229.194 269.332L226.951 266.339Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.446 262.221L229.699 264.28L231.941 267.273L234.689 265.215L232.446 262.221Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.971 291.976L196.224 294.035L198.466 297.028L201.214 294.97L198.971 291.976Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.457 297.963L200.709 300.022L202.952 303.015L205.7 300.957L203.457 297.963Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.943 303.95L205.195 306.009L207.438 309.002L210.185 306.944L207.943 303.95Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.428 309.937L209.681 311.996L211.924 314.989L214.671 312.931L212.428 309.937Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.914 315.924L214.167 317.983L216.409 320.976L219.157 318.918L216.914 315.924Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.4 321.911L218.652 323.97L220.895 326.963L223.643 324.904L221.4 321.911Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.885 327.898L223.138 329.957L225.381 332.95L228.128 330.891L225.885 327.898Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.371 333.885L227.624 335.943L229.867 338.937L232.614 336.878L230.371 333.885Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.857 339.872L232.109 341.93L234.352 344.924L237.1 342.865L234.857 339.872Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.184 261.098L237.437 263.156L239.679 266.15L242.427 264.091L240.184 261.098Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.67 267.084L241.922 269.143L244.165 272.137L246.913 270.078L244.67 267.084Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 273.071L246.408 275.13L248.651 278.123L251.398 276.065L249.155 273.071Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.641 279.058L250.894 281.117L253.137 284.11L255.884 282.052L253.641 279.058Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.127 285.045L255.379 287.104L257.622 290.097L260.37 288.039L258.127 285.045Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.613 291.032L259.865 293.091L262.108 296.084L264.855 294.026L262.613 291.032Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.098 297.019L264.351 299.078L266.594 302.071L269.341 300.013L267.098 297.019Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.584 303.006L268.837 305.065L271.079 308.058L273.827 305.999L271.584 303.006Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.07 308.993L273.322 311.052L275.565 314.045L278.313 311.986L276.07 308.993Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.09 343.8L239.343 345.859L241.586 348.852L244.333 346.794L242.09 343.8Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.585 339.683L244.838 341.742L247.081 344.735L249.828 342.676L247.585 339.683Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08 335.566L250.333 337.624L252.576 340.618L255.323 338.559L253.08 335.566Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.575 331.449L255.828 333.507L258.071 336.501L260.818 334.442L258.575 331.449Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.07 327.331L261.323 329.39L263.566 332.383L266.313 330.325L264.07 327.331Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.565 323.214L266.818 325.273L269.061 328.266L271.808 326.208L269.565 323.214Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.061 319.097L272.313 321.156L274.556 324.149L277.303 322.091L275.061 319.097Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.437 263.156L198.971 291.976L239.343 345.859L277.808 317.038L237.437 263.156Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.709 281.683L198.971 291.976L203.457 297.963L217.195 287.67L212.709 281.683Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.195 287.67L206.204 295.905L210.69 301.892L221.68 293.657L217.195 287.67Z",
    fill: "#FF8577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.922 269.143L233.68 275.319L269.565 323.214L277.808 317.038L241.922 269.143Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.079 308.058L257.342 318.351L264.07 327.331L277.808 317.038L271.079 308.058Z",
    fill: "#A0301B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.067 282.29L236.077 290.525L238.32 293.518L249.31 285.284L247.067 282.29Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.31 285.284L235.573 295.577L237.816 298.57L251.553 288.277L249.31 285.284Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.553 288.277L237.816 298.57L244.544 307.551L258.282 297.258L251.553 288.277Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.282 297.258L247.292 305.492L254.02 314.472L265.01 306.238L258.282 297.258Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.263 308.297L254.02 314.472L258.506 320.459L266.749 314.284L262.263 308.297Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.749 314.284L261.254 318.401L263.496 321.394L268.991 317.277L266.749 314.284Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.661 304.696L222.914 306.755L225.157 309.748L227.904 307.69L225.661 304.696Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.904 307.69L222.409 311.807L224.652 314.8L230.147 310.683L227.904 307.69Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4 312.742L224.652 314.8L226.895 317.794L229.642 315.735L227.4 312.742Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.147 310.683L227.4 312.742L229.642 315.735L232.39 313.677L230.147 310.683Z",
    fill: "#003478"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.39 313.677L226.895 317.794L229.138 320.787L234.633 316.67L232.39 313.677Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.633 316.67L231.885 318.729L234.128 321.722L236.876 319.664L234.633 316.67Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.614 327.709L235.866 329.768L240.352 335.755L243.099 333.696L238.614 327.709Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.109 323.592L238.614 327.709L240.857 330.703L246.352 326.585L244.109 323.592Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 328.644L240.857 330.703L243.099 333.696L245.847 331.637L243.604 328.644Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.595 329.579L243.099 333.696L245.342 336.69L250.837 332.572L248.595 329.579Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.351 317.416L246.856 321.533L249.099 324.527L254.594 320.41L252.351 317.416Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.847 322.468L249.099 324.527L251.342 327.52L254.09 325.462L251.847 322.468Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.837 323.403L251.342 327.52L253.585 330.514L259.08 326.397L256.837 323.403Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.594 311.24L255.099 315.358L257.342 318.351L262.837 314.234L260.594 311.24Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.837 314.234L257.342 318.351L259.585 321.344L265.08 317.227L262.837 314.234Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.08 317.227L259.585 321.344L261.827 324.338L267.323 320.221L265.08 317.227Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.923 278.312L233.175 280.371L237.661 286.358L240.408 284.299L235.923 278.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.156 282.241L237.661 286.358L239.904 289.351L245.399 285.234L243.156 282.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.913 279.247L238.165 281.306L240.408 284.299L243.156 282.241L240.913 279.247Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.441 511.006L324.69 486.045L321.917 489.907L356.667 514.867L359.441 511.006Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.39 520.413L314.194 484.36L311.421 488.221L361.617 524.275L364.39 520.413Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.339 529.821L303.698 482.674L300.925 486.536L366.566 533.683L369.339 529.821Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.427 536.456L297.064 483.762L294.29 487.623L367.654 540.317L370.427 536.456Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.515 543.09L290.429 484.85L284.883 492.573L365.968 550.813L371.515 543.09Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.744 495.346L284.883 492.573L259.922 527.323L263.784 530.097L288.744 495.346Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.968 550.813L362.107 548.039L337.147 582.79L341.008 585.564L365.968 550.813Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.008 585.564L259.922 527.323L254.376 535.046L335.461 593.286L341.008 585.564Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.6 590.513L258.237 537.819L255.464 541.68L328.827 594.374L331.6 590.513Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.965 591.601L259.325 544.454L256.551 548.315L322.192 595.462L324.965 591.601Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.47 589.915L264.274 553.862L261.501 557.723L311.696 593.776L314.47 589.915Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.974 588.23L269.223 563.27L266.45 567.131L301.201 592.091L303.974 588.23Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.667 514.867L321.917 489.906L319.143 493.768L353.894 518.728L356.667 514.867Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.617 524.275L311.421 488.221L308.647 492.082L358.843 528.136L361.617 524.275Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.566 533.682L300.925 486.536L298.152 490.397L363.792 537.544L366.566 533.682Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.653 540.317L294.29 487.623L288.744 495.346L362.107 548.039L367.653 540.317Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.605 498.119L288.744 495.346L263.784 530.097L267.645 532.87L292.605 498.119Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.107 548.039L358.245 545.266L333.285 580.017L337.147 582.79L362.107 548.039Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.147 582.79L263.784 530.097L258.237 537.819L331.6 590.513L337.147 582.79Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.739 587.739L262.098 540.593L259.325 544.454L324.965 591.601L327.739 587.739Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.243 586.054L267.047 550L264.274 553.862L314.47 589.915L317.243 586.054Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.747 584.368L271.996 559.408L269.223 563.27L303.974 588.23L306.747 584.368Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.727 502.088L311.421 488.221L308.647 492.082L327.953 505.949L330.727 502.088Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.092 503.176L300.925 486.536L298.152 490.397L321.319 507.037L324.092 503.176Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.319 507.037L294.29 487.623L288.744 495.346L315.772 514.759L321.319 507.037Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.894 518.728L319.143 493.768L316.37 497.629L351.121 522.589L353.894 518.728Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.843 528.136L308.647 492.082L305.874 495.943L356.07 531.997L358.843 528.136Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.931 534.77L302.013 493.17L296.466 500.892L354.384 542.493L359.931 534.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.246 545.266L292.605 498.119L267.645 532.87L333.285 580.017L358.246 545.266Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.424 577.244L271.506 535.643L265.959 543.366L323.878 584.966L329.424 577.244Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.016 582.193L269.821 546.139L267.047 550L317.243 586.054L320.016 582.193Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.521 580.507L274.77 555.547L271.996 559.408L306.747 584.368L309.521 580.507Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.041 512.584L325.18 509.81L316.86 521.394L320.721 524.167L329.041 512.584Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.903 515.357L329.041 512.583L326.268 516.445L330.129 519.218L332.903 515.357Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.99 521.991L330.129 519.218L324.583 526.941L328.444 529.714L333.99 521.991Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.257 560.603L294.673 552.283L291.9 556.145L303.484 564.465L306.257 560.603Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.761 558.918L291.9 556.145L289.127 560.006L292.988 562.779L295.761 558.918Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.71 568.326L292.988 562.779L290.214 566.64L297.937 572.187L300.71 568.326Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.937 572.187L294.076 569.414L291.302 573.275L295.164 576.048L297.937 572.187Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.064 554.076L338.342 548.53L335.569 552.391L343.291 557.938L346.064 554.076Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.43 555.164L335.569 552.391L332.795 556.252L336.656 559.025L339.43 555.164Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.518 561.799L332.795 556.252L330.022 560.113L337.744 565.66L340.518 561.799Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.007 515.25L288.146 512.476L279.826 524.06L283.687 526.833L292.007 515.25Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.095 521.884L289.234 519.111L286.461 522.972L290.322 525.745L293.095 521.884Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.73 520.796L295.869 518.023L287.548 529.607L291.41 532.38L299.73 520.796Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.809 530.802L317.948 528.028L315.175 531.89L319.036 534.663L321.809 530.802Z",
    fill: "#C0392B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.036 534.663L315.175 531.89L312.401 535.751L316.263 538.524L319.036 534.663Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.124 541.297L308.54 532.977L305.767 536.839L317.35 545.159L320.124 541.297Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.263 538.524L312.401 535.751L309.628 539.612L313.489 542.385L316.263 538.524Z",
    fill: "#FF6B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35 545.159L305.767 536.839L302.993 540.7L314.577 549.02L317.35 545.159Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.716 546.246L306.855 543.473L304.081 547.334L307.942 550.108L310.716 546.246Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.943 550.108L304.081 547.334L301.308 551.196L305.169 553.969L307.943 550.108Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.262 538.524L312.401 535.751L306.855 543.473L310.716 546.247L316.262 538.524Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.401 535.751L308.54 532.977L305.767 536.839L309.628 539.612L312.401 535.751Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35 545.159L313.489 542.385L310.716 546.247L314.577 549.02L317.35 545.159Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.356 523.079L323.495 520.306L320.721 524.167L324.582 526.94L327.356 523.079Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.396 557.83L298.535 555.057L295.761 558.918L299.622 561.691L302.396 557.83Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.818 527.431L296.956 524.657L294.183 528.519L298.044 531.292L300.818 527.431Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.568 552.391L331.707 549.617L328.934 553.479L332.795 556.252L335.568 552.391Z",
    fill: "#6A6A6A"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7089 477.003L57.0884 481.919L62.0049 490.54L70.6254 485.623L65.7089 477.003Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3986 479.461L57.0884 481.919L62.0049 490.54L66.3152 488.082L61.3986 479.461Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.501 454.879L95.8806 459.795L100.797 468.416L109.418 463.499L104.501 454.879Z",
    fill: "#5A4A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.191 457.337L95.8806 459.795L100.797 468.416L105.107 465.957L100.191 457.337Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.728 461.041L57.6947 492.998L60.153 497.309L116.186 465.351L113.728 461.041Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.496 462.893L55.8427 499.767L60.7592 508.387L125.413 471.513L120.496 462.893Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.103 473.972L65.0695 505.929L67.5277 510.239L123.561 478.282L121.103 473.972Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394 487.475L60.153 497.308L62.6112 501.619L79.8522 491.786L77.394 487.475Z",
    fill: "#E88648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8521 491.786L66.9214 499.161L69.3797 503.471L82.3104 496.096L79.8521 491.786Z",
    fill: "#F0A066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.182 473.365L58.9073 515.156L61.3656 519.466L134.64 477.676L132.182 473.365Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.95 475.217L57.0553 521.924L86.5545 573.647L168.449 526.94L138.95 475.217Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.139 529.399L90.8647 571.189L95.7813 579.81L169.056 538.019L164.139 529.399Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9169 507.175L61.3656 519.466L68.7404 532.397L90.2917 520.105L82.9169 507.175Z",
    fill: "#E88648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2917 520.105L73.0507 529.938L80.4255 542.869L97.6665 533.036L90.2917 520.105Z",
    fill: "#F0A066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6665 533.036L84.7357 540.411L89.6522 549.032L102.583 541.657L97.6665 533.036Z",
    fill: "#F0A066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.95 475.217L117.399 487.509L146.898 539.232L168.449 526.94L138.95 475.217Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.074 514.01L130.903 531.217L138.278 544.148L168.449 526.94L161.074 514.01Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.315 496.129L83.5231 518.254L85.9813 522.564L124.774 500.439L122.315 496.129Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.084 497.981L81.671 525.022L96.4206 550.884L143.833 523.843L129.084 497.981Z",
    fill: "#C45911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.523 526.301L100.731 548.425L103.189 552.736L141.981 530.611L139.523 526.301Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9121 515.189L85.9813 522.564L90.8979 531.184L103.829 523.809L98.9121 515.189Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.829 523.81L95.2081 528.726L97.6664 533.036L106.287 528.12L103.829 523.81Z",
    fill: "#E88648"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.084 497.981L116.153 505.356L130.903 531.217L143.833 523.843L129.084 497.981Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.533 510.272L103.222 512.731L117.972 538.592L122.282 536.134L107.533 510.272Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.377 511.502L103.222 512.731L117.972 538.592L120.127 537.363L105.377 511.502Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.824 531.824L115.514 534.282L120.43 542.902L124.74 540.444L119.824 531.824Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.669 533.053L115.514 534.282L117.972 538.592L120.127 537.363L117.669 533.053Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.745 540.477L100.091 577.351L102.55 581.662L167.203 544.788L164.745 540.477Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.893 547.246L106.86 579.203L111.777 587.824L167.81 555.866L162.893 547.246Z",
    fill: "#A0440D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.499 558.325L116.087 585.366L118.545 589.676L165.958 562.635L163.499 558.325Z",
    fill: "#8A3A0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.838 507.781L63.2175 512.698L102.55 581.662L111.17 576.745L71.838 507.781Z",
    fill: "#8A6A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5278 510.239L63.2175 512.698L102.55 581.662L106.86 579.203L67.5278 510.239Z",
    fill: "#9A7A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5995 517.631L72.4443 518.86L101.944 570.583L104.099 569.354L74.5995 517.631Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0459 537.953L80.4254 542.869L85.3419 551.49L93.9625 546.573L89.0459 537.953Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7357 540.411L80.4254 542.869L82.8837 547.18L87.1939 544.721L84.7357 540.411Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.871 475.824L119.251 480.74L158.583 549.704L167.204 544.788L127.871 475.824Z",
    fill: "#8A6A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.561 478.282L119.251 480.74L158.583 549.704L162.893 547.246L123.561 478.282Z",
    fill: "#9A7A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.633 485.673L128.478 486.902L157.977 538.625L160.132 537.396L130.633 485.673Z",
    fill: "#6A5A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.079 505.995L136.459 510.912L141.375 519.532L149.996 514.616L145.079 505.995Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.769 508.454L136.459 510.912L138.917 515.222L143.227 512.764L140.769 508.454Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7185 469.022L76.7877 476.397L79.246 480.707L92.1767 473.332L89.7185 469.022Z",
    fill: "#8A6A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4869 470.874L74.9357 483.165L77.3939 487.476L98.9452 475.184L96.4869 470.874Z",
    fill: "#9A7A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1767 473.332L79.246 480.707L81.7042 485.017L94.635 477.642L92.1767 473.332Z",
    fill: "#AA8A6A"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_1295_1557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.163 421.821L304.03 360.92L302.05 365.118L431.183 426.019L433.163 421.821Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.215 367.083L302.05 365.118L286.211 398.703L290.376 400.668L306.215 367.083Z",
    fill: "#D16D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.183 426.019L427.018 424.054L411.179 457.64L415.344 459.604L431.183 426.019Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.344 459.604L286.211 398.703L284.231 402.902L413.364 463.802L415.344 459.604Z",
    fill: "#B04E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.018 424.054L306.215 367.083L290.376 400.668L411.179 457.64L427.018 424.054Z",
    fill: "#F5EAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.375 380.834L306.215 367.083L290.376 400.668L319.535 414.42L335.375 380.834Z",
    fill: "#F0E6D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.468 383.916L334.385 382.934L333.395 385.033L335.478 386.015L336.468 383.916Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.488 388.114L332.405 387.132L331.415 389.231L333.498 390.213L334.488 388.114Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.508 392.312L330.425 391.33L329.435 393.429L331.518 394.411L332.508 392.312Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.528 396.51L328.445 395.528L327.455 397.627L329.538 398.609L330.528 396.51Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.548 400.709L326.465 399.726L325.475 401.825L327.558 402.808L328.548 400.709Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.568 404.907L324.485 403.924L323.495 406.024L325.578 407.006L326.568 404.907Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.588 409.105L322.505 408.123L321.515 410.222L323.598 411.204L324.588 409.105Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.608 413.303L320.525 412.321L319.535 414.42L321.618 415.402L322.608 413.303Z",
    fill: "#B0A090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.773 385.571L308.607 383.606L306.627 387.804L310.793 389.769L312.773 385.571Z",
    fill: "#5A7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.104 389.5L312.772 385.571L310.793 389.769L319.124 393.698L321.104 389.5Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.269 391.464L321.104 389.5L319.124 393.698L323.289 395.663L325.269 391.464Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.918 383.337L310.587 379.408L308.607 383.606L316.938 387.535L318.918 383.337Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.958 391.734L306.627 387.804L304.647 392.003L312.978 395.932L314.958 391.734Z",
    fill: "#6A9FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.388 396.82L341.726 388.962L339.746 393.16L356.408 401.018L358.388 396.82Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.74 404.947L339.746 393.16L337.766 397.358L362.76 409.145L364.74 404.947Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.568 414.77L373.071 408.876L371.091 413.074L383.588 418.968L385.568 414.77Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.548 410.572L383.382 408.607L381.402 412.805L385.568 414.77L387.548 410.572Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.588 418.968L379.422 417.003L377.442 421.202L381.608 423.166L383.588 418.968Z",
    fill: "#E74C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.541 422.359L395.879 414.501L393.899 418.699L410.561 426.557L412.541 422.359Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.727 428.522L393.899 418.699L391.919 422.897L412.747 432.72L414.727 428.522Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.303 411.648L333.806 405.754L331.826 409.953L344.323 415.846L346.303 411.648Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.131 421.471L350.469 413.613L348.489 417.811L365.151 425.669L367.131 421.471Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.794 429.329L375.462 425.4L373.483 429.598L381.814 433.527L383.794 429.329Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.456 437.187L387.959 431.293L385.979 435.492L398.476 441.385L400.456 437.187Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.919 413.034L330.837 412.052L327.867 418.349L329.949 419.331L332.919 413.034Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.168 415.981L335.002 414.016L332.032 420.313L336.198 422.278L339.168 415.981Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.333 417.945L341.251 416.963L338.281 423.26L340.364 424.243L343.333 417.945Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.499 419.91L345.416 418.927L342.446 425.225L344.529 426.207L347.499 419.91Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.747 422.857L349.582 420.892L346.612 427.189L350.778 429.154L353.747 422.857Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.913 424.821L355.83 423.839L352.86 430.136L354.943 431.118L357.913 424.821Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.161 427.768L359.996 425.803L357.026 432.101L361.191 434.065L364.161 427.768Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.327 429.733L366.244 428.75L363.274 435.048L365.357 436.03L368.327 429.733Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.493 431.697L370.41 430.715L367.44 437.012L369.523 437.994L372.493 431.697Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.741 434.644L374.575 432.679L371.606 438.977L375.771 440.941L378.741 434.644Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.907 436.608L380.824 435.626L377.854 441.923L379.937 442.906L382.907 436.608Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.072 438.573L384.989 437.591L382.02 443.888L384.102 444.87L387.072 438.573Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.321 441.52L389.155 439.555L386.185 445.852L390.351 447.817L393.321 441.52Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.486 443.484L395.403 442.502L392.434 448.799L394.516 449.782L397.486 443.484Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.735 446.431L399.569 444.467L396.599 450.764L400.765 452.728L403.735 446.431Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.677 398.3L297.512 396.335L295.532 400.534L299.697 402.498L301.677 398.3Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.091 403.211L303.76 399.282L301.78 403.48L310.111 407.409L312.091 403.211Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.34 406.158L314.174 404.193L312.194 408.392L316.36 410.356L318.34 406.158Z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.477,
    height: 81.3063,
    fill: "white",
    transform: "translate(260.914 72.277) rotate(31.5887)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.066,
    height: 87.2586,
    fill: "white",
    transform: "translate(274 243.649) rotate(-24.4626)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.97,
    height: 81.564,
    fill: "white",
    transform: "translate(66 92.2931) rotate(-22.7577)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151.292,
    height: 115.091,
    fill: "white",
    transform: "translate(76.0769 358.975) rotate(-22.0033)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.6636,
    height: 93.5121,
    fill: "white",
    transform: "translate(184 289.172) rotate(-36.8425)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.85,
    height: 118.85,
    fill: "white",
    transform: "translate(299.347 456.136) rotate(35.6881)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124.05,
    height: 148.86,
    fill: "white",
    transform: "translate(22.0001 490.507) rotate(-29.6974)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_1295_1557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 161.197,
    height: 92.8325,
    fill: "white",
    transform: "translate(305.598 336) rotate(25.249)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.aaf47fc928dd1fffb9ca813c12f5940b.svg";
export { ForwardRef as ReactComponent };